import { defineRule } from "vee-validate";

defineRule("required", (value) => {
  if (!value || (typeof value === "string" && !value.length)) {
    return "This field is required";
  }

  return true;
});
